import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    {
        name: "About Department",
        content: (
            <p>Here you'll find information about the department.</p>
        )
    },
    { name: "Courses Offered", content: <p>Here you'll find information about the courses offered.</p> },
    {
        name: "Faculty Members",
        content: (
            <div className="mb-4">
                <h4 className="mb-3 text-primary">Faculty Members</h4>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover align-middle">
                        <thead className="table-primary text-center">
                            <tr>
                                <th>Photo</th>
                                <th>Department</th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Highest Qualification</th>
                                <th>Contact</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr>
                                <td style={{ width: "140px" }}>
                                    <img
                                        src={require("../assets/Photos/डॉ कुलदीप सिंह (धर्मशास्त्र विभाग).jpeg")}
                                        alt="Dr. Kuldeep Singh"
                                        className="img-fluid rounded"
                                        style={{ height: "120px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>Dharma Shastra</td>
                                <td>Dr. Kuldeep Singh</td>
                                <td>In-charge, Assistant Professor</td>
                                <td>—</td>
                                <td>9248300000</td>
                                <td>
                                    <a href="mailto:hoddharamshastra@mvsu.ac.in">hoddharamshastra@mvsu.ac.in</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    },

    { name: "Time Table", content: <p>The time table will be displayed here.</p> },
    { name: "Facilities", content: <p>Details of the department's facilities will be here.</p> },
    { name: "Seminar/Conference/Workshop", content: <p>Information about seminars, conferences, and workshops will be here.</p> },
    { name: "Research Scholars", content: <p>Information about research scholars will be here.</p> },
    { name: "Achievements", content: <p>Details of the department's achievements will be here.</p> },
    { name: "Contact", content: <p>Contact details will be here.</p> },
];

export default function DepartmentDharmaStudies_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDept, setSelectedDept] = useState("About Department");

    const handleItemClick = (deptName) => {
        setSelectedDept(deptName);
        setShowSidebar(false);
    };

    const selectedContent = departments.find(d => d.name === selectedDept)?.content
        || <p className="text-secondary">Please select a section.</p>;

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <nav className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3 bg-white`}>
                <h5 className="text-center fw-bold mb-3 text-dark">Department of Theology</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            role="button"
                            className={`mb-1 p-2 rounded small shadow-sm ${selectedDept === dept.name ? "bg-primary text-white fw-semibold" : "bg-light text-dark"}`}
                            style={{ cursor: "pointer", transition: "background 0.3s" }}
                            onClick={() => handleItemClick(dept.name)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </nav>

            {/* Main Content */}
            <section className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto tex"> {/* Added overflow-auto here */}
                <h4 className="mb-3 text-primary text-center">{selectedDept}</h4> {/* Display selected department name as header */}
                {selectedContent}
            </section>
        </div>
    );
}